import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import { pxToRem } from '../../utils';
import { Button } from '../Button';
import { Text } from '../Typography';

import { Toast } from './Toast';

const ClickableText = styled(Text)`
  &:hover {
    cursor: pointer;
  }
`;

const Container = styled.div<{ invertMotion?: boolean }>`
  height: ${pxToRem(120)};
  ${({ invertMotion }) => invertMotion && 'display: flex'};
`;

function useVisibleTimer(
  timeout: number
): [boolean, (isVisible: boolean) => void] {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isVisible) {
      const timer = window.setTimeout(() => {
        setIsVisible(false);
      }, timeout);

      return () => {
        window.clearTimeout(timer);
      };
    }
    return undefined;
  }, [timeout, isVisible]);

  return [isVisible, setIsVisible];
}

export const ExampleToastButton = () => {
  const [isVisible, setIsVisible] = useVisibleTimer(2800);

  const onClick = () => {
    setIsVisible(true);
  };

  return (
    <Container>
      <Toast
        className={'example-toast'}
        position={'center'}
        isVisible={isVisible}
        toastMessage={'This is a toast notification'}
      >
        <Button size="regular" level="primary" onClick={onClick}>
          Click me for Toast 🍞
        </Button>
      </Toast>
    </Container>
  );
};

export const ExampleToastText = () => {
  const [isVisible, setIsVisible] = useVisibleTimer(2800);

  const onClick = () => {
    setIsVisible(true);
  };

  return (
    <Container>
      <Toast
        className={'example-toast'}
        position={'center'}
        isVisible={isVisible}
        toastMessage={'This is a toast notification'}
      >
        <ClickableText onClick={onClick} bold>
          Click me for Toast 🍞
        </ClickableText>
      </Toast>
    </Container>
  );
};

export const ExampleToastButtonInverted = () => {
  const [isVisible, setIsVisible] = useVisibleTimer(2800);

  const onClick = () => {
    setIsVisible(true);
  };

  return (
    <Container invertMotion>
      <Toast
        className={'example-toast'}
        position={'center'}
        isVisible={isVisible}
        invertMotion={true}
        toastMessage={'This is a toast notification that pops up'}
      >
        <Button size="regular" level="primary" onClick={onClick}>
          Click me for inverted Toast 🍞
        </Button>
      </Toast>
    </Container>
  );
};
